import { VALUE_ALL } from '../Filters.constants'
import type { FilterValues } from '../Filters.types'

/**
 * Remove empty values and "ALL"
 */
export function sanitizeQueryParams(filters: FilterValues) {
  return Object.keys(filters).reduce((acc, filterKey) => {
    const value = filters[filterKey as keyof FilterValues]

    return value && value !== VALUE_ALL ? { ...acc, [filterKey]: value } : acc
  }, {} as FilterValues)
}
